import strFunc from "@/lib/lyg/string";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";

function PreListArea(props: any) {
  let myProps = {
    todo_dailyc_data: {},
    todo_dailyc_arr: [],
    refresh_data: (inData: any) => { },
    loading_data:{},
    set_loading_data: (inData: any) => { },
    callback_delete_todoc: (inData: any) => { },
    ...props
  };
  let todo_dailyc_data = myProps.todo_dailyc_data;
  let todo_dailyc_arr = myProps.todo_dailyc_arr;

  const go_delete_todo_dailyc_by_ajax=(inData:any)=>{
    let opt_obj={
      data_arr:[],
      ...inData
    };
    if(opt_obj.data_arr.length==0){
      alert("삭제할 데이터가 없습니다.");
      return false;
    }
    // if(!confirm("정말 삭제하시겠습니까?")){
    //   return false;
    // }
    let form_json_data = {
      "data_arr": opt_obj.data_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.set_loading_data({
            is_display: true,
            text: "삭제 되었습니다.",
          });
          setTimeout(() => {
            myProps.set_loading_data({
              ...myProps.loading_data,
              is_display: false,
            });
          }, 600);
          myProps.callback_delete_todoc({
            todo_dailyc_arr: opt_obj.data_arr,
          });
          myProps.refresh_data();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const get_pre_list_tags=()=>{
    let tags=todo_dailyc_arr.map((item:any,idx:number)=>{
      if(item.a_subject!=todo_dailyc_data.a_subject){
        return "";
      }
      let star_cnt=parseInt(strFunc.uncomma(item.a_star_cnt));
      if(item.a_teacher_star){
        star_cnt+=parseInt(strFunc.uncomma(item.a_teacher_star));
      }
      return (
        <tr key={idx}>
          <td className="text-center">{idx+1}</td>
          <td className="text-center">{item.a_sort}</td>
          <td>
            <MultyLineTextView
              text={item.a_memo}
            ></MultyLineTextView>
          </td>
          <td className="text-center">
            {star_cnt}
            {star_cnt>0&&
              <span>
                ({item.a_star_cnt}+{item.a_teacher_star})
              </span>
            }
          </td>
          <td className="text-center">
            <button className="btn-s btn-red"
              onClick={()=>{
                go_delete_todo_dailyc_by_ajax({
                  data_arr:[item]
                });
              }}
            >X</button>
          </td>
        </tr>
      );
    });
    return tags;
  };

  return (
    <div>
      <div className="write_table_small">
        <table>
          <colgroup>
            <col width={"20px"}></col>
            <col width={"30px"}></col>
            <col width={"100px"}></col>
            <col width={"50px"}></col>
            <col width={"50px"}></col>
          </colgroup>
          <thead>
            <tr>
              <th>No.</th>
              <th>구분</th>
              <th>메모</th>
              <th>별</th>
              <th>관리</th>
            </tr>
          </thead>
          <tbody>
            {get_pre_list_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default PreListArea;
